import i18n from '@/lang' //
import {colorRgba} from "@/utils";

let green = '#28C76F',
  yellow = '#FF9F43',
  grayBg = '#BABFC7',
  grayColor = '#BABFC7';

export function getStaus(status){
  switch (status) {
    case 1:
      return i18n.t('withgold.statusDuring');
    case 2:
      return i18n.t('Settlement');
    case 3:
      return  i18n.t('settled');
  }
}

export function getStyle(status) {
  if(status == 1){
    return {
      backgroundColor: colorRgba(green,0.12),
      color: green,
    }
  }else if(status == 2){
    return {
      backgroundColor: colorRgba(yellow,0.12),
      color: yellow,
    }
  }else if(status == 3){
    return {
      backgroundColor: colorRgba(grayBg,0.12),
      color: '#626262',
    }
  }
}
